import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a25bc8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "border-lighten flex h-full items-center whitespace-nowrap rounded border px-5 text-sm" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ItemDetailsOverviewButton',
  props: {
  label: {
    type: String,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'my-1.5 min-h-[34px] rounded': true,
      'button-inactive-state': !props.active,
      'button-active-state': props.active,
    })
  }, [
    _createElementVNode("button", _hoisted_1, _toDisplayString(props.label), 1)
  ], 2))
}
}

})